import * as _ from 'lodash-es';

type AttributeValue = string | boolean | null | undefined;

const attr = (name: string, value: AttributeValue) => {
  if (value == null || value === false) {
    return null;
  }

  if (value === true) {
    return `${name}`;
  }

  return `${name}="${_.escape(value)}"`;
};

const buildHTML = (
  tagName: keyof HTMLElementTagNameMap,
  attributes: Record<string, AttributeValue>,
  children?: string,
) => {
  const attributeString = Object.entries(attributes)
    .toSorted((a, b) => a[0].localeCompare(b[0]))
    .map(([k, v]) => attr(k, v))
    .filter((item) => !!item)
    .join(' ');

  const startTag = `<${tagName}${attributeString ? ` ${attributeString}` : ''}`;

  return children ? `${startTag}>${children}</${tagName}>` : `${startTag} />`;
};

export default buildHTML;
